import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Component imports
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// Page imports
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Industries from "@/pages/Industries";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

// ScrollToTop Helper to ensure page transitions start at the top of the canvas
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen bg-white">
      <BrowserRouter>
        {/* Scroll restoration helper */}
        <ScrollToTop />
        
        {/* Persistent High-Contrast Header */}
        <Navbar />
        
        {/* Main Routed Views */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* 9 Compliance & Legal Pages */}
            <Route path="/terms-of-service" element={<Legal />} />
            <Route path="/terms-conditions" element={<Legal />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/consumer-privacy" element={<Legal />} />
            <Route path="/refund-policy" element={<Legal />} />
            <Route path="/cancellation-policy" element={<Legal />} />
            <Route path="/sms-terms" element={<Legal />} />
            <Route path="/cookie-policy" element={<Legal />} />
            <Route path="/accessibility" element={<Legal />} />
            
            {/* Fallback redirect */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Secure Trust Footer on every single page */}
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
